<template>
  <div class="articleContent">
    <div class="title">
      <span class="title-sty">办件结果公开</span>
    </div>
    <div class="announcement">
      <ul class="InformationInquiry">
        <div
          v-for="(item, index) in processing"
          :key="item.value"
          :style="{ width: 100 / processing.length + '%' }"
          class="InformationInquiryItem"
          @click="eventBus(item.value)"
        >
          <li
            class="InformationInquiryItemLi"
            :class="{ 'is-active': activeValue == item.value }"
          >
            <span>{{ item.label }}</span>
          </li>
          <el-divider
            direction="vertical"
            v-if="index != processing.length - 1"
          ></el-divider>
        </div>
      </ul>
      <div class="superior">
        <div class="block">
          <span class="demonstration">发布日期：</span>
          <el-date-picker
            popper-class="timeclass"
            v-model="dateStr"
            type="date"
            placeholder="开始时间"
            @change="timeStaChange()"
          >
          </el-date-picker>
          <span style="font-size: 16px; margin-left: 5px; margin-right: 5px"
            >至</span
          >
          <el-date-picker
            popper-class="timeclass"
            v-model="dateEnd"
            type="date"
            placeholder="结束时间"
            @change="timeEndChange()"
          >
          </el-date-picker>
          <!-- <el-date-picker
            v-model="timeData"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            popper-class="dateclass"
            @change="timeDataChange()"
          >
          </el-date-picker> -->
        </div>
        <div class="block">
          <el-input
            v-model="searchOne"
            maxlength="24rem"
            placeholder="请输入文号或标题"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              size="small"
              @click="search()"
            ></el-button>
          </el-input>
          <el-button autofocus class="reset" @click="resetOn()">重置</el-button>
        </div>
      </div>
      <div style="padding: 0 20px; text-align: center">
        <el-table
          :data="publicNotice"
          border
          fit
          :stripe="true"
          style="width: 100%"
          :header-cell-style="{
            background: '#ebe6db',
            color: '#585856',
            borderColor: '#585856',
          }"
          :cell-style="{ borderColor: '#585856' }"
        >
          <el-table-column
            align="center"
            type="index"
            :index="count"
            label="序号"
            width="60"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="infoNum"
            label="文号"
            min-width="160px"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="infoTitle"
            label="标题"
            min-width="490px"
          >
            <template slot-scope="scope">
                             
              <router-link
                :to="{
                  path: '/home/gov-info-disc',
                  query: { id: scope.row.id, type: 3 },
                }"
                style="
                  color: #606266;
                  text-decoration: underline;
                  font-size: 12px;
                "
                >{{ scope.row.infoTitle }}</router-link
              >
                           
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="postOffice"
            label="发布机构"
            min-width="170px"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="publishDate"
            label="发布日期"
            min-width="150px"
          >
            <template slot-scope="scope">{{
              scope.row.publishDate | formatDate
            }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          popper-class="pageclass"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { URL_PORTAL_RESULTS } from "../../../utils/api";
import util from "../../../utils/util";
import { processing } from "../../../utils/staticDict";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  props: [],
  components: {},
  data() {
    return {
      activeValue: "",
      // 文字内容
      processing: processing,
      // 默认第一页
      currentPage: 1,
      // 搜索
      searchOne: "",
      // 表格属性
      publicNotice: [],
      // 总页数
      total: 100,
      // 返回日期
      timeData: [],
      dateList: [],
      dateStr: "",
      dateEnd: "",
      pagesize: 10,
      // 日期
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 标志物
      marker:
        "'文物保护管理','考古发掘管理','文物进出境审核管理','博物馆和馆藏文物管理'",
    };
  },
  computed: {},
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  methods: {
    _formatDate(time) {
      if (time === null) return "";
      let date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let m = date.getMonth() + 1,
        mm = m < 10 ? "0" + m : m;
      let d = date.getDate(),
        dd = d < 10 ? "0" + d : d;
      let h = date.getHours(),
        hh = h < 10 ? "0" + h : h;
      let i = date.getMinutes(),
        ii = i < 10 ? "0" + i : i;
      let s = date.getSeconds(),
        ss = s < 10 ? "0" + s : s;
      return (
        date.getFullYear() +
        "-" +
        mm +
        "-" +
        dd +
        "  " +
        hh +
        ":" +
        ii +
        ":" +
        ss
      );
    },
    // 请求列表数据
    getList(val) {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosThree");
      if (this.dateStr !== "") {
        this.dateStr = this._formatDate(this.dateStr);
      }
      if (this.dateEnd == "") {
        var dateEnds = "";
      } else {
        var dateEnds = this._formatDate(this.dateEnd);
      }
      let params = {
        pageSize: this.pagesize,
        pageNumber: this.currentPage,
        timeFrom: this.dateStr,
        timeTo: dateEnds,
        title: this.searchOne,
        announceType: val,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.post(Url + URL_PORTAL_RESULTS, params).then((res) => {
        if (res.status == 200) {
          this.total = res.data.recordsTotal;
          this.publicNotice = res.data.data;
        }
      });
    },
    eventBus(value) {
      this.activeValue = value;
      if (value == "whole") {
        this.getList(
          "'文物保护管理','考古发掘管理','文物进出境审核管理','博物馆和馆藏文物管理'"
        );
        this.marker =
          "'文物保护管理','考古发掘管理','文物进出境审核管理','博物馆和馆藏文物管理'";
        this.resetOn();
      }
      if (value == "culturalRelicsProtection") {
        this.getList("文物保护");
        this.marker = "文物保护";
        this.resetOn();
      }
      if (value == "archaeologicalExcavation") {
        this.getList("考古发掘");
        this.marker = "考古发掘";
        this.resetOn();
      }
      if (value == "museumManagement") {
        this.getList("博物馆管理");
        this.marker = "博物馆管理";
        this.resetOn();
      }
      if (value == "culturalRelics") {
        this.getList("文物进出境");
        this.marker = "文物进出境";
        this.resetOn();
      }
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList(this.marker);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList(this.marker);
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    timeStaChange() {
      this.getList(this.marker);
    },
    timeEndChange() {
      this.getList(this.marker);
    },
    // 重置
    resetOn() {
      this.dateStr = "";
      this.dateEnd = "";
      this.searchOne = "";
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList(this.marker);
    },
    // 搜索
    search() {
      this.getList(this.marker);
    },
  },
  mounted() {
    this.activeValue = this.processing.length ? this.processing[0].value : "";
    this.getList(
      "'文物保护管理','考古发掘管理','文物进出境审核管理','博物馆和馆藏文物管理'"
    );
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/base";
@import "../../../styles/comSty";
.InformationInquiry {
  display: flex;
  padding: 0 20px;
  margin: 20px 0;
  .InformationInquiryItem {
    display: flex;
    border-bottom: 1px solid #dddddd;
    .InformationInquiryItemLi {
      list-style: none;
      padding: 5px 0 10px;
      font-size: 16px;
      text-align: center;
      width: 95%;
      cursor: pointer;
    }
    .is-active {
      color: @theme-color;
      font-weight: 700;
      border-bottom: 3px solid;
    }
    /deep/ .el-divider--vertical {
      background-color: #2c3e50;
      height: 1.6rem;
      margin: 10px 8px;
    }
  }
}
.demonstration {
  font-size: 16px !important;
}
/deep/.el-range-editor.is-active,
.el-range-editor.is-active:hover {
  border-color: #b71c1c;
}
/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 380px;
}
/deep/ .el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 16px !important;
}
/deep/ .el-range-separator {
  font-size: 16px !important;
}
/deep/ .el-button {
  font-size: 16px !important;
}
a:hover {
  color: #b71c1c !important;
}
</style>
